export enum CUSTOMIZATION {
    /**
     * @value Color theme
     */
    COLOR_THEME = 'ADMIN.CUSTOMER.MOBILE_COLOR_THEME',
    /**
     * @value Mobile app logo
     */
    MOBILE_APP_LOGO = 'ADMIN.CUSTOMER.MOBILE_APP_LOGO',
    /**
     * @value Use as navigation background
     */
    PRIMARY_AS_BACKGROUND = 'ADMIN.CUSTOMER.MOBILE_PRIMARY_AS_BACKGROUND',
    /**
     * @value Used for the navigation bar and tab bar.
     */
    PRIMARY_COLOR_HELPER = 'ADMIN.CUSTOMER.MOBILE_PRIMARY_COLOR_HELPER',
    /**
     * @value First color value (hexadecimal)
     */
    PRIMARY_COLOR_LABEL = 'ADMIN.CUSTOMER.MOBILE_PRIMARY_COLOR_LABEL',
    /**
     * @value Your mobile settings have been saved.
     */
    SAVE_SUCCESS = 'ADMIN.MOBILE_CUSTOMIZATION_SAVE_SUCCESS',
    /**
     * @value Used for hint items, links and some buttons
     */
    SECONDARY_COLOR_HELPER = 'ADMIN.CUSTOMER.MOBILE_SECONDARY_COLOR_HELPER',
    /**
     * @value Second color value (hexadecimal)
     */
    SECONDARY_COLOR_LABEL = 'ADMIN.CUSTOMER.MOBILE_SECONDARY_COLOR_LABEL',
    /**
     * @value Customization
     */
    TITLE_CUSTOMIZATION = 'ADMIN.NAV.MOBILE_SETTINGS_CUSTOMIZATION',
    /**
     * @value Please upload a png file, with a max-width of 480 px and a height equal to 96 px and a weight less than 300ko
     */
    UPLOAD_LOGO_HELPER = 'ADMIN.CUSTOMER.MOBILE_APP_LOGO_HELPER',
}
